import GetDataRequest from '../entities/GetDataRequest'
export class SalesOfficeRequestTypeFilter {
    
    public ID?: number;
    public SalesOfficeID?: number;
    public RequestTypeID?: number;
    public RequestTypeIDs?: number[] = [];
    public SalesOfficeIDs?: number[] = [];
    GetDataRequest: GetDataRequest;
}

export default SalesOfficeRequestTypeFilter;